import { render, staticRenderFns } from "./ComingSoonPlayerCell.vue?vue&type=template&id=2730f085&scoped=true"
import script from "./ComingSoonPlayerCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoonPlayerCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComingSoonPlayerCell.vue?vue&type=style&index=0&id=2730f085&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730f085",
  null
  
)

export default component.exports